import React from "react";
import { Paper } from "@material-ui/core";
import { baseUrl, config } from "../../../../services/config";
import { useEffect } from "react";
import { Spinner, Table } from "react-bootstrap";
import { useState, useRef } from "react";
import ReactToPrint from "react-to-print";
import { useSelector } from "react-redux";
import { upperCase } from "lodash";
import { DownloadTableExcel } from "react-export-table-to-excel";

const pageStyle = `
  @page {
    size: a4 landscape !important;
}
`;

const Eobi = () => {
  const [loading, setLoading] = useState(false);
  //for print
  const [printloading, setprintloading] = React.useState(false);
  const [text, setText] = React.useState("old boring text");
  const componentRef = useRef(null);
  const tableRef = useRef(null);
  const onBeforeGetContentResolve = React.useRef(null);
  const [campusId, setCampusId] = useState("");
  const user = useSelector((state) => state.user.user);
  const [campusData, setCampusData] = useState(user.campuses || []);
  let authtoken = localStorage.getItem("userToken");
  const [reportData, setreportData] = useState([]);
  const [unitName, setUnitName] = useState("");
  const [icon, setIcon] = useState([]);
  let serial = 1;
  useEffect(() => {
    getSettingData();
  }, []);

  const getSettingData = async () => {
    await fetch(`${baseUrl}/get-settings`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data.payload);
        setUnitName(upperCase(data.payload.settings.unit_name));
        setIcon(data.payload.settings.logo_file);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getEobi = async () => {
    setLoading(true);

    const data = {
      campus_id: campusId,
    };

    await fetch(`${baseUrl}/staff-eobi-report`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        setLoading(false);

        console.log(data, "======");
        if (data.metadata) {
          if (data.metadata.success) {
            setreportData(data.payload);
          }
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log("err", err);
      });
  };

  //for print
  const handleBeforePrint = React.useCallback(() => {
    console.log("`onBeforePrint` called");
  }, []);

  const handleOnBeforeGetContent = React.useCallback(() => {
    console.log("`onBeforeGetContent` called");
    setprintloading(true);
    setText("Loading new text...");

    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;

      setTimeout(() => {
        setprintloading(false);
        setText("New, Updated Text!");
        resolve();
      }, 2000);
    });
  }, [setprintloading, setText]);

  const handleAfterPrint = React.useCallback(() => {
    console.log("`onAfterPrint` called");
  }, []);
  return (
    <>
      <Paper
        style={{ marginTop: "10px", marginBottom: "10px", padding: "15px" }}
      >
        <div className="row">
          <div className="col-md-4">
            <label>
              <b> Select Campus</b>
            </label>
            <div className="d-flex flex-column">
              <select
                style={{ height: 40 }}
                className="form-select"
                name="year_id"
                aria-label="Default select example"
                onChange={(e) => setCampusId(e.target.value)}
              >
                <option selected value="">
                  {" "}
                  All Campuses
                </option>
                {campusData &&
                  campusData.map((item) => (
                    <option value={item.id}>{item.name}</option>
                  ))}
              </select>
            </div>
          </div>
          <div className="col-md-4 mt-9">
            <button className="btn btn-primary" onClick={() => getEobi()}>
              Show
            </button>
            {reportData?.length > 0 ? (
              <>
                <ReactToPrint
                  documentTitle={`EOBI Report`}
                  pageStyle={pageStyle}
                  onAfterPrint={handleAfterPrint}
                  onBeforeGetContent={handleOnBeforeGetContent}
                  onBeforePrint={handleBeforePrint}
                  removeAfterPrint={true}
                  trigger={() => (
                    <button
                      // onClick={() => console.log("dfsdfsdfd")}
                      disabled={printloading ? true : false}
                      style={{ marginLeft: "10px" }}
                      className="btn btn-success button_blue button_blue"
                    >
                      {printloading ? <span>Printing..</span> : "Print"}
                    </button>
                  )}
                  content={() => componentRef.current}
                />

                <DownloadTableExcel
                  filename="EOBI Report"
                  sheet="EOBI Report"
                  currentTableRef={tableRef.current}
                >
                  <button className="btn btn-primary mx-2"> Export </button>
                </DownloadTableExcel>
              </>
            ) : null}
          </div>
        </div>
        {loading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Spinner
              class="text-center mt-5"
              variant="info"
              animation="border"
            />
          </div>
        ) : (
          <Table responsive className="mt-5">
            <thead>
              <tr>
                <th className="">Sr.#</th>
                <th className="">Name</th>
                <th className="">Scale</th>
                <th className="">E.Code</th>
                <th className="">Designation</th>
                <th className="">DOB</th>
                <th className="">Joining Date</th>
                <th className="">Leaving Date</th>
                <th className="">Amount</th>
                <th className="">Eobi No</th>
                <th className="">Remarks</th>
              </tr>
            </thead>
            {reportData.length > 0
              ? reportData.map((item) =>
                  item.employees.length > 0 ? (
                    <>
                      <tbody>
                        <tr>
                          <td></td>
                          <td colSpan={11}>
                            <div className="row">
                              <div className="col-md-12">
                                <p
                                  className="text-start text-color-primary"
                                  style={{
                                    fontSize: "1.5rem",
                                    fontWeight: "500",
                                    width: "max-content",
                                  }}
                                >
                                  {item.Campus}
                                </p>
                              </div>
                            </div>
                          </td>
                        </tr>

                        {item.employees.length > 0
                          ? item.employees.map((subitem, index) => (
                              <tr
                                key={subitem.emp_code || index}
                                className={
                                  subitem?.job_status_id == "1"
                                    ? "text-dark"
                                    : "text-danger"
                                }
                              >
                                <td>{index + 1}</td> {/* Serial Number */}
                                <td>{subitem.full_name}</td>
                                <td>{subitem.pay_scale?.payscale}</td>
                                <td>{subitem.emp_code}</td>
                                <td>{subitem.designation?.name}</td>
                                <td>{subitem.dob ?? "---"}</td>
                                <td>{subitem.joining_date ?? "---"}</td>
                                <td>{subitem.leaving_date ?? "---"}</td>
                                <td>{subitem.salary_deduction?.eobi}</td>
                                <td>{subitem.eobi_no}</td>
                                <td></td>
                              </tr>
                            ))
                          : null}
                      </tbody>
                    </>
                  ) : null
                )
              : null}
          </Table>
        )}

        {/* ///for print /////// */}

        <div
          ref={componentRef}
          id="printSection"
          style={{ visibility: "hidden" }}
        >
          <div className="row p-3">
            <img style={{ height: 100, width: 100 }} src={icon} alt="icon" />

            <div className="col-md-10">
              <h1>{unitName}</h1>
              <h5>Staff Eobi Report</h5>
            </div>
          </div>
          <table style={{ width: "100%" }}>
            <tr>
              <th style={{ border: "1px solid black", textAlign: "center" }}>
                Sr. #
              </th>
              <th style={{ border: "1px solid black", textAlign: "center" }}>
                Name
              </th>
              <th style={{ border: "1px solid black", textAlign: "center" }}>
                Scale
              </th>
              <th style={{ border: "1px solid black", textAlign: "center" }}>
                E.Code
              </th>
              <th style={{ border: "1px solid black", textAlign: "center" }}>
                Designation
              </th>
              <th style={{ border: "1px solid black", textAlign: "center" }}>
                DOB
              </th>
              <th style={{ border: "1px solid black", textAlign: "center" }}>
                Joining Date
              </th>
              <th style={{ border: "1px solid black", textAlign: "center" }}>
                Leaving Date
              </th>
              <th style={{ border: "1px solid black", textAlign: "center" }}>
                Amount
              </th>
              <th style={{ border: "1px solid black", textAlign: "center" }}>
                Eobi No
              </th>
              <th style={{ border: "1px solid black", textAlign: "center" }}>
                Remarks
              </th>
            </tr>
            {reportData.length > 0
              ? reportData.map((item) =>
                  item.employees.length > 0 ? (
                    <tbody>
                      <>
                        <tr>
                          <td
                            colSpan={11}
                            className="text-start p-2"
                            style={{
                              fontSize: "1.5rem",
                              fontWeight: "500",
                              color: `${config.txtColor}`,
                              border: "1px solid black",
                            }}
                          >
                            {item.Campus}
                          </td>
                        </tr>
                        {item.employees.length > 0
                          ? item.employees.map((subitem) => (
                              <tr>
                                <td
                                  style={{
                                    border: "1px solid black",
                                    padding: "1px",
                                    whiteSpace: "none",
                                  }}
                                  className={
                                    subitem?.job_status_id == "1"
                                      ? "text-dark"
                                      : "text-danger"
                                  }
                                >
                                  {serial++} {/* Serial Number */}
                                </td>
                                <td
                                  className={
                                    subitem?.job_status_id == "1"
                                      ? "text-dark"
                                      : "text-danger"
                                  }
                                  style={{
                                    border: "1px solid black",
                                    padding: "1px",
                                    whiteSpace: "none",
                                  }}
                                >
                                  {subitem.full_name}
                                </td>
                                <td
                                  className={
                                    subitem?.job_status_id == "1"
                                      ? "text-dark"
                                      : "text-danger"
                                  }
                                  style={{
                                    border: "1px solid black",
                                    padding: "1px",
                                    whiteSpace: "none",
                                  }}
                                >
                                  {subitem.pay_scale?.payscale}
                                </td>
                                <td
                                  className={
                                    subitem?.job_status_id == "1"
                                      ? "text-dark"
                                      : "text-danger"
                                  }
                                  style={{
                                    border: "1px solid black",
                                    padding: "1px",
                                    whiteSpace: "none",
                                  }}
                                >
                                  {subitem.emp_code}
                                </td>
                                <td
                                  className={
                                    subitem?.job_status_id == "1"
                                      ? "text-dark"
                                      : "text-danger"
                                  }
                                  style={{
                                    border: "1px solid black",
                                    padding: "1px",
                                    whiteSpace: "none",
                                  }}
                                >
                                  {subitem.designation?.name}
                                </td>
                                <td
                                  className={
                                    subitem?.job_status_id == "1"
                                      ? "text-dark"
                                      : "text-danger"
                                  }
                                  style={{
                                    border: "1px solid black",
                                    padding: "1px",
                                    whiteSpace: "none",
                                  }}
                                >
                                  {subitem?.dob ?? "---"}
                                </td>
                                <td
                                  className={
                                    subitem?.job_status_id == "1"
                                      ? "text-dark"
                                      : "text-danger"
                                  }
                                  style={{
                                    border: "1px solid black",
                                    padding: "1px",
                                    whiteSpace: "none",
                                  }}
                                >
                                  {subitem.joining_date ?? "---"}
                                </td>

                                <td
                                  className={
                                    subitem?.job_status_id == "1"
                                      ? "text-dark"
                                      : "text-danger"
                                  }
                                  style={{
                                    border: "1px solid black",
                                    padding: "1px",
                                    whiteSpace: "none",
                                  }}
                                >
                                  {subitem.leaving_date ?? "---"}
                                </td>
                                <td
                                  className={
                                    subitem?.job_status_id == "1"
                                      ? "text-dark"
                                      : "text-danger"
                                  }
                                  style={{
                                    border: "1px solid black",
                                    padding: "1px",
                                    whiteSpace: "none",
                                  }}
                                >
                                  {subitem.salary_deduction?.eobi}
                                </td>
                                <td
                                  className={
                                    subitem?.job_status_id == "1"
                                      ? "text-dark"
                                      : "text-danger"
                                  }
                                  style={{
                                    border: "1px solid black",
                                    padding: "1px",
                                    whiteSpace: "none",
                                  }}
                                >
                                  {subitem.eobi_no}
                                </td>
                                <td
                                  style={{
                                    border: "1px solid black",
                                    padding: "1px",
                                    whiteSpace: "none",
                                  }}
                                ></td>
                              </tr>
                            ))
                          : null}
                      </>
                    </tbody>
                  ) : null
                )
              : null}
          </table>
        </div>

        {/* For Export */}
        <div ref={tableRef} id="printSection" style={{ visibility: "hidden" }}>
          <Table ref={tableRef} style={{ display: "none" }}>
            <thead>
              <tr>
                <th className="">Sr.#</th>
                <th className="">Name</th>
                <th className="">Scale</th>
                <th className="">E.Code</th>
                <th className="">Designation</th>
                <th className="">DOB</th>
                <th className="">Joining Date</th>
                <th className="">Leaving Date</th>
                <th className="">Amount</th>
                <th className="">Eobi No</th>
                <th className="">Remarks</th>
              </tr>
            </thead>
            {reportData.length > 0
              ? reportData.map((item) =>
                  item.employees.length > 0 ? (
                    <>
                      <tbody>
                        <tr>
                          <td></td>
                          <td colSpan={11}>
                            <div className="row">
                              <div className="col-md-12">
                                <p
                                  className="text-start text-color-primary pt-2"
                                  style={{
                                    fontSize: "1.5rem",
                                    fontWeight: "500",
                                    width: "max-content",
                                  }}
                                >
                                  {item.Campus}
                                </p>
                              </div>
                            </div>
                          </td>
                        </tr>

                        {item.employees.length > 0
                          ? item.employees.map((subitem, index) => (
                              <tr
                                key={subitem.emp_code || index}
                                className={
                                  subitem?.job_status_id == "1"
                                    ? "text-dark"
                                    : "text-danger"
                                }
                              >
                                <td>{index + 1}</td> {/* Serial Number */}
                                <td>{subitem.full_name}</td>
                                <td>{subitem.pay_scale?.payscale}</td>
                                <td>{subitem.emp_code}</td>
                                <td>{subitem.designation?.name}</td>
                                <td>{subitem.dob ?? "---"}</td>
                                <td>{subitem.joining_date ?? "---"}</td>
                                <td>{subitem.leaving_date ?? "---"}</td>
                                <td>{subitem.salary_deduction?.eobi}</td>
                                <td>{subitem.eobi_no}</td>
                                <td></td>
                              </tr>
                            ))
                          : null}
                      </tbody>
                    </>
                  ) : null
                )
              : null}
          </Table>
        </div>
      </Paper>
    </>
  );
};

export default Eobi;
